import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
function AngleUpDuotoneGlyph(props, svgRef) {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: [_jsx("path", { d: "M63.52 351.84a23.94 23.94 0 01-33.85 0L7.05 329.33l-.18-.18a23.77 23.77 0 01.18-33.61l96.42-96.15L160 255.86z", opacity: 0.4 }, void 0),
            _jsx("path", { d: "M313.13 295.81l-.18-.17L177 160.11a24 24 0 00-34-.11l-39.51 39.39L256.33 352a23.94 23.94 0 0033.85 0L313 329.43a23.78 23.78 0 00.13-33.62z", className: "prefix__fa-primary" }, void 0)] }), void 0));
}
const ForwardRef = React.forwardRef(AngleUpDuotoneGlyph);
export default ForwardRef;
